<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'margin: 4px'
            : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="!ready" />
        <div v-if="ready">
          <crud-list
            v-model="gestores"
            :headers="headers"
            :slots="['item.telefones']"
            :actions="actions"
            :show-expand="true"
            :permission="'list_gestor'"
            :sort-by="['nome']"
            :sort-desc="[false]"
            export-pdf-xlsx
          >
            <template v-slot:expanded-item="{ item }">
              <td
                v-if="item.unidades && item.unidades.length"
                :colspan="headers.length"
              >
                <div>
                  <v-simple-table
                    dense
                    class="mb-5 mt-5"
                    style="border: 1px solid lightgrey; max-width: 85%;"
                  >
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th
                            colspan="3"
                            style="text-align: center;"
                          >
                            Unidades de negócio
                          </th>
                        </tr>
                        <tr>
                          <th>
                            CNPJ
                          </th>
                          <th>
                            Nome Fantasia
                          </th>
                          <th>
                            Razão Social
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="unidades in item.unidades"
                          :key="unidades.nome_fantasia"
                        >
                          <td>{{ unidades.cnpj }}</td>
                          <td>{{ unidades.nome_fantasia }}</td>
                          <td>{{ unidades.razao_social }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>
              </td>
            </template>
            <template v-slot:btnCadastro>
              <v-col>
                <v-btn
                  class="text-none text-white"
                  block
                  color="primary"
                  title="Cadastrar novo gestor"
                  rounded
                  @click="$router.push({ path: 'gestores/cadastrar' })"
                >
                  <v-icon
                    dark
                    left
                  >
                    mdi-file-plus
                  </v-icon>
                  Cadastrar
                </v-btn>
              </v-col>
            </template>
            <template v-slot:[`item.telefones`]="{ item }">
              <div
                v-for="(telefone, index) in item.telefones"
                :key="index"
              >
                <span v-if="telefone">
                  {{ `${index + 1}:  ${telefone}` }}
                  <br>
                </span>
              </div>
            </template>
          </crud-list>
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import GestoresStore, { BOOTSTRAP, DELETE_GESTOR } from '@/store/modules/gestores'
  import { mapState, mapActions } from 'vuex'
  import { sortDateTime } from '../../utils/sorts'

  export default {
    data () {
      return {
        search: '',
        actions: [
          {
            title: 'Editar gestor',
            color: 'info darken-3',
            click: item => this.editarGestor(item),
            icon: 'mdi-pencil',
          },
          {
            title: 'Excluir Gestor',
            color: 'red darken-3',
            click: item => this.DELETE_GESTOR(item),
            icon: 'mdi-trash-can-outline',
          },
        ],
        headers: [
          { text: '', value: 'data-table-expand', sortable: false, groupable: false, width: '10px' },
          { text: '', value: 'actions', sortable: false, groupable: false, width: '40px' },
          { align: 'left', sortable: true, groupable: false, text: 'CPF', value: 'cpf', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: true, groupable: false, text: 'Nome', value: 'nome', width: 'auto', floatingfilter: true, report: true },
          { align: 'left', sortable: false, groupable: false, text: 'Telefones', value: 'telefones', width: 'auto', report: true, styleXLSX: { type: 'telefone' } },
          { align: 'left', sortable: true, groupable: false, text: 'RG', value: 'rg', width: 'auto' },
          { align: 'left', sortable: true, groupable: true, text: 'Papel', value: 'roles.description', width: 'auto' },
          { align: 'left', sortable: true, groupable: false, text: 'Email', value: 'email', width: 'auto', floatingfilter: true, report: true },
          { align: 'center', sortable: true, groupable: false, text: 'Data de Nascimento', value: 'data_nascimento', width: 'auto', sort: sortDateTime },
          { align: 'left', sortable: true, groupable: true, text: 'Sexo', value: 'sexo', width: 'auto' },
        ],
      }
    },
    computed: {
      ...mapState('gestores', ['ready', 'gestores']),
    },
    async created () {
      if (!this.$store.hasModule('gestores')) { this.$store.registerModule('gestores', GestoresStore) }
      this.BOOTSTRAP()
    },
    methods: {
      ...mapActions('gestores', [BOOTSTRAP, DELETE_GESTOR]),
      editarGestor ({ id }) {
        this.$router.push({
          path: `/${this.$user.get().role}/gestores/alterar`,
          query: { id },
        })
      },
    },
  }
</script>
